module.exports = __webpack_public_path__ + "img/software_worldox.3b6ab51a.jpg";